/**
 * Created by Rodrigo Quesada on 13/02/17.
 */
import {Component, Input, OnDestroy, Output, EventEmitter} from '@angular/core';
import {ReplaySubject} from 'rxjs';

@Component({
    selector: 'accordion',
    template: `<div role="tablist"><ng-content></ng-content></div>`,
    host: {
        'class': 'panel-group'
    }
})
export class AccordionComponent {

    @Output('openGroup') openGroup$ = new ReplaySubject<number|undefined>(1);

    groups: Array<AccordionGroupComponent> = [];

    addGroup(group: AccordionGroupComponent) {
        this.groups.push(group);
    }

    gotOpen(group: AccordionGroupComponent) {
        const groupIndex = this.groups.indexOf(group);
        this._closeOthers(groupIndex);
        this.openGroup$.next(groupIndex);
    }

    private _closeOthers(openIndex: number) {
        this.groups.forEach((group: AccordionGroupComponent, index) => {
            if (index !== openIndex) group.isOpen = false;
        });
    }

    gotClose(group: AccordionGroupComponent) {
        if (!this.groups.find(value => value.isOpen)) this.openGroup$.next(undefined);
    }

    removeGroup(group: AccordionGroupComponent) {
        const index = this.groups.indexOf(group);
        if (index !== -1) {
            this.groups.splice(index, 1);
        }
    }
}

@Component({
    selector: 'accordion-group',
    template: require('./accordion.component.html'),
    styles: [require('./accordion.component.scss')],
    host: {
        class: 'accordion-group'
    }
})
export class AccordionGroupComponent implements OnDestroy {
    private _isOpen: boolean = false;

    @Input() heading: string;
    @Input() actionClass: string;
    @Input() actionLabel: string;
    @Output() action = new EventEmitter<boolean>();

    @Input()
    set isOpen(value: boolean) {
        if (this._isOpen !== value) {
            setTimeout(() => {
                this._isOpen = value;
                if (value) this.accordion.gotOpen(this);
                else this.accordion.gotClose(this);
            });
        }
    }

    get isOpen() {
        return this._isOpen;
    }

    constructor(private accordion: AccordionComponent) {
        this.accordion.addGroup(this);
    }

    ngOnDestroy() {
        this.accordion.removeGroup(this);
    }

    toggleOpen(event: MouseEvent) {
        event.preventDefault();
        this.isOpen = !this.isOpen;
    }

    triggerAction(event: Event) {
        event.stopPropagation();
        this.action.next(true);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/accordion/accordion.component.ts